import { createClient } from '@supabase/supabase-js';
import { Database } from '../types/supabase';

// Valores padrão para desenvolvimento (apenas como fallback seguro)
const DEFAULT_SUPABASE_URL = 'https://qassqhqlzrwsjtelppku.supabase.co';
const DEFAULT_SUPABASE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFhc3NxaHFsenJ3c2p0ZWxwcGt1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQxMTI2NzcsImV4cCI6MjA1OTY4ODY3N30.vbHQa9P7vdK_HA0hFIBcNFtea3259FQ2pis0P3alqWA';

// Obter URLs e chaves do ambiente Vite
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || DEFAULT_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY || DEFAULT_SUPABASE_KEY;

// Log para depuração em desenvolvimento
if (import.meta.env.DEV) {
  console.log('Inicializando Supabase com:', { 
    url: supabaseUrl === DEFAULT_SUPABASE_URL ? '[URL PADRÃO DE DESENVOLVIMENTO]' : supabaseUrl.substring(0, 15) + '...',
    key: supabaseKey === DEFAULT_SUPABASE_KEY ? '[CHAVE PADRÃO DE DESENVOLVIMENTO]' : '***' + supabaseKey.substring(supabaseKey.length - 4)
  });
}

// Criar cliente Supabase com tipagem
export const supabase = createClient<Database>(
  supabaseUrl,
  supabaseKey,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true
    }
  }
);